import {useMemo} from 'react'
import {useSelector} from 'react-redux'
import {currentOrgSelector, orgEnvsSelector, selfSelector} from './selectors'

export * from './selectors'

export function useShared() {
	const me = useSelector(selfSelector)
	const organisation = useSelector(currentOrgSelector)
	const myEnvs = useSelector(orgEnvsSelector)

	return useMemo(
		() => ({
			me,
			organisation,
			myEnvs,
			meMultiEnv: myEnvs.length > 1,
		}),
		[me, organisation, myEnvs],
	)
}
